import React from "react";

const NotebookDeleteModal = ({
    pendingDeletePage,
    onCancel,
    onConfirm,
}) => {
    if (!pendingDeletePage) {
        return null;
    }

    return (
        <div
            className="
                fixed
                inset-0
                z-[99999]
                flex
                items-center
                justify-center
                bg-black/85
                px-4
                backdrop-blur-sm
            "
        >
            <div
                className="
                    w-full
                    max-w-md
                    rounded-[28px]
                    border
                    border-[#ffd166]/45
                    bg-[#05070d]
                    p-6
                    shadow-[0_0_40px_rgba(255,209,102,0.18)]
                "
            >
                <p
                    className="
                        text-[10px]
                        font-semibold
                        uppercase
                        tracking-[0.2em]
                        text-[#d8b4fe]
                    "
                >
                    Confirm Delete
                </p>

                <h3
                    className="
                        mt-2
                        font-display
                        text-2xl
                        text-[#ffd166]
                    "
                >
                    Delete Notebook Page?
                </h3>

                <p
                    className="
                        mt-3
                        text-sm
                        leading-6
                        text-[#b0b8d6]
                    "
                >
                    You are about to delete
                    <span className="font-semibold text-[#fff3c4]">
                        {" "}
                        {pendingDeletePage.title ||
                            "this notebook page"}
                    </span>
                    .
                </p>

                <p
                    className="
                        mt-2
                        text-xs
                        text-red-200/80
                    "
                >
                    This action cannot be undone.
                </p>

                <div className="mt-6 flex justify-end gap-2">
                    <button
                        type="button"
                        onClick={onCancel}
                        className="
                            rounded-xl
                            border
                            border-[#c084fc]/35
                            bg-black
                            px-4
                            py-2
                            text-xs
                            font-semibold
                            text-[#d8b4fe]
                            transition
                            hover:border-[#c084fc]/70
                            hover:text-[#f3e8ff]
                        "
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        onClick={onConfirm}
                        className="
                            rounded-xl
                            border
                            border-red-400/45
                            bg-red-950/30
                            px-4
                            py-2
                            text-xs
                            font-semibold
                            text-red-200
                            transition
                            hover:border-red-300
                            hover:bg-red-950/50
                            hover:text-red-100
                        "
                    >
                        Delete Page
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NotebookDeleteModal;